<!-- Header section -->
<login-header></login-header>

<!-- Hero section -->
<div class="lp_hero">
    <div class="lp_hero_content d-grid">
        <div class="lp_hero_text"> 
            <h1 class="h1 text-capitalize">Help your clients protect and build their legacy.</h1>
            <p>Family Central provides your clients a safe haven for important documents and building their legacies for generations to come.</p>
            <a routerLink="/professional/signup" class="primary_btn">Sign up</a>
        </div>
        <div class="lp_hero_image">
            <div class="welcome_video_wrapper card_wrapper">
                <div class="welcome_video_content card_container">
                    <div class="welcome_video ratio ratio-16x9">
                        <iframe src="https://player.vimeo.com/video/910873205?h=6096bd7bfa&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen title="Welcome, Trusted Professional Advisors">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Feature sections -->
<div class="lp_features">
    <div class="px-90 m-auto text-center">
        <div class="feature_content">
            <div class="features_top mb-5">
                <h2 class="h2 mb-5">The only app in the market that provides your clients with a safe haven for their most valuable information. </h2>
                <p class="paragraph">Family Central works with Trusted Professional Advisors that are looking for ways to manage clients’ important financial and life planning information in a secure and consistent manner.</p>
            </div>

            <div class="features_list d-flex">
                <div class="single_feature">
                    <div class="feature_img mb-4">
                        <img src="/assets/images/professionals/feature_1.webp" width="208" height="270" alt="" loading="lazy">
                    </div>
                    <p class="paragraph_text">Legacy Videos</p>
                </div>
                <div class="single_feature">
                    <div class="feature_img mb-3">
                        <img src="/assets/images/professionals/feature_2.webp" width="208" height="230" alt="" loading="lazy">
                    </div>
                    <p class="paragraph_text">Personal Vault</p>
                </div>
                <div class="single_feature">
                    <div class="feature_img mb-4">
                        <img src="/assets/images/professionals/feature_3.webp" alt="" width="208" height="270" loading="lazy">
                    </div>
                    <p class="paragraph_text">Live Customer Care</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Is right for you section -->
<div class="is_right">
    <div class="px-90 m-auto text-center">
        <div class="is_right_content py-5">
            <div class="features_top mb-5">
                <h2 class="h2 mb-4 text-capitalize">Everything in the right place</h2>
                <p class="paragraph">Help your clients manage their everyday life by organizing important documents and prepare for life’s inevitable emergencies.</p>
            </div>

            <div class="features_list d-grid">
                <!-- First Image -->
                <div class="image-container">
                    <img src="/assets/images/professionals/right_palce_1.webp" alt="Image 1" class="image">
                    <div class="overlay">
                        <h4 class="header">Planning</h4>
                        <p class="paragraph_isright">Empower your clients to plan ahead and set up important documents and actions for those inevitable life emergencies.</p>
                    </div>
                </div>

                <!-- Second Image -->
                <div class="image-container">
                    <img src="/assets/images/professionals/right_palce_2.webp" alt="Image 2" class="image">
                    <div class="overlay">
                        <h4 class="header">Legacy</h4>
                        <p class="paragraph_isright">Help your clients leave a legacy for their loved ones for generations to come.</p>
                    </div>
                </div>

                <!-- Third Image -->
                <div class="image-container">
                    <img src="/assets/images/professionals/right_palce_3.webp" alt="Image 3" class="image">
                    <div class="overlay">
                        <h4 class="header">Organization</h4>
                        <p class="paragraph_isright">Provide a platform where your clients can manage their day-to-day efficiently so they can spend more time with those who matter the most — their family.</p>
                    </div>
                </div>
            </div>

            <div class="features_top mt-5">
                <h2 class="h2 mb-4 text-capitalize">Your clients are safe with us</h2>
                <p class="paragraph">At Family Central, your clients’ critical information is safeguarded with the most up-to-date data security because our members deserve peace of mind.</p>
            </div>

        </div>
    </div>
</div>

<!-- Security tech section -->
<div class="securuty_tech">
    <div class="px-90 m-auto text-center">
        <div class="security_content py-5">
            <div class="security_parent d-grid">
                <div class="security_chaild">
                    <div class="security_img">
                        <img src="/assets/images/professionals/wowrack-logo.svg" alt=""/>
                    </div>
                </div>
                <div class="security_chaild">
                    <div class="security_text">
                        <p class="sec_para">Wowrack.com provides our infrastructure services, private hosting and cloud infrastructure with bank encrypted levels of security.</p>
                    </div>
                </div>

                <div class="security_chaild">
                    <div class="security_img">
                        <img src="/assets/images/professionals/microsoft-azure-logo.svg" alt=""/>
                    </div>
                </div>
                <div class="security_chaild">
                    <div class="security_text">
                        <p class="sec_para">Azure.microsoft.com provide Family Central with data protection through 256-bit AES standard and encryption on our applications and services at their global data centers.</p>
                    </div>
                </div>

                <div class="security_chaild">
                    <div class="security_img">
                        <img src="/assets/images/professionals/arctic-logo.svg" alt=""/>
                    </div>
                </div>
                <div class="security_chaild">
                    <div class="security_text">
                        <p class="sec_para">Arcticwolf.com provides 24/7 monitoring detection, risk management and proactive security posture for global  fortune 100  companies and Family Central.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Advisor to contact section -->
<div class="advisor_contact">
    <div class="px-90 m-auto text-center">
        <div class="resource_content py-5">
            <div class="features_top mb-5">
                <h2 class="h2 mb-4">A resource for Advisors to connect</h2>
                <p class="paragraph">Meet all of your clients’ needs in one easy-to-use platform and continue to build trust and provide a new value to your clients that sets your practice apart.</p>
            </div>

            <div class="advisor_resource d-grid pt-5">
                <div class="resource_list"> 
                    <!-- Tab panes -->
                    <div class="tab-content flex-grow-1">
                        <!-- questions of FAQ's -->
                        <div id="myAccount" class="tab-pane fade show active">
                            <div class="faq-tab-content">
                                <div class="faq-accordion" id="accountAccordion">
                                    <!-- loop of questions  -->
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="accordion-button collapsed btn" data-bs-toggle="collapse" data-bs-target="#accountQues1" aria-expanded="true" aria-controls="accountQues1">
                                                Organize
                                            </a>
                                        </div>
                                        <div id="accountQues1"  data-bs-parent="#accountAccordion" aria-expanded="false" class="accordion-collapse show collapse" aria-labelledby="founderques1">
                                            <div class="card-body">
                                                Your client information stored securely and organized, but always at your fingertips
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="accordion-button collapsed btn" data-bs-toggle="collapse" data-bs-target="#accountQues2" aria-expanded="false" aria-controls="accountQues1">
                                                Protect
                                            </a>
                                        </div>
                                        <div id="accountQues2"  data-bs-parent="#accountAccordion" aria-expanded="false" class="accordion-collapse collapse" aria-labelledby="founderques1">
                                            <div class="card-body">
                                                Your client information stored securely and organized, but always at your fingertips
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header">
                                            <a class="accordion-button collapsed btn" data-bs-toggle="collapse" data-bs-target="#accountQues3" aria-expanded="false" aria-controls="accountQues1">
                                                Connect
                                            </a>
                                        </div>
                                        <div id="accountQues3"  data-bs-parent="#accountAccordion" aria-expanded="false" class="accordion-collapse collapse" aria-labelledby="founderques1">
                                            <div class="card-body">
                                                Your client information stored securely and organized, but always at your fingertips
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resource_img">
                    <img src="/assets/images/professionals/iphone-in-portrait-position-and-macbook-pro-over-a-flat.webp" alt="" />
                </div>
            </div>
        </div>
    </div>

</div>


<!-- Ask us anything section -->
<div class="ask_anything mb-5">
    <div class="px-90 m-auto">
        <div class="ask_anything_top text-center mb-5">
            <h2 class="h2">Ask us anything</h2>
            <p>We are always here to answer your questions.</p>
            <p>or feel free to <a routerLink="/contactus" class="bright-blue">Contact Us.</a></p>
        </div>
        <div class="ask_anything_tabs">
            <div class="ask_tabs_accordion" id="professionalsAccordion">
                <div class="card">
                    <div class="card-header">
                        <a class="btn" data-bs-toggle="collapse" href="#proQuestion1" aria-expanded="true">How much does Family Central cost for my clients?</a>
                    </div>
                    <div id="proQuestion1" class="collapse show" data-bs-parent="#professionalsAccordion">
                        <div class="card-body">
                            Family Central offers a free 14-day trial period for subscribers. For a family (up to 8 members, including the subscriber), the subscriber pays $199 annually for one year or $299 annually for two years. Your subscription includes 250 GB of storage. If additional family members are needed, the add-on fee is $99 annually for an additional 8 family members. If additional storage is needed, the add-on fee $99 for an addition 250 GB of storage.
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion2">
                            Can I cancel at any time?
                        </a>
                    </div>
                    <div id="proQuestion2" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body">
                            If a client chooses to cancel their subscription, they will be given 30 days to move the data to an alternate storage location.  After 30 days, we will delete all data from our records.
                        </div>
                    </div>
                </div>
                
                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion3">
                            What features can I offer my clients?
                        </a>
                    </div>
                    <div id="proQuestion3" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                           <p> The platform provides a centralized solution for comprehensive life preparation, ensuring your clients are ready for various situations. It offers a convenient space to organize essential information, including:</p>
                           <ul>
                                <li>Financial Planning</li>
                                <li>Wills and Estate Plans</li>
                                <li>Medical Records</li>
                                <li>Passwords</li>
                                <li>Video Recordings for your loved ones</li>
                           </ul>
                            <p>By utilizing this service, you empower your clients to navigate life's uncertainties with ease and ensure that your important details are securely stored in one accessible location.</p>
                        </div>
                    </div>
                </div>
                
                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion4">
                            How many clients can I manage on the platform?
                        </a>
                    </div>
                    <div id="proQuestion4" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body lp_p">
                           
                           <p> For a family, accommodating up to 8 members, including the primary account holder, we offer two subscription options:</p>
                           <ul>
                                <li class="pb-3">
                                Choose between an annual payment of $199 for one year or opt for a two-year plan at $299 annually, both of which include a generous 250 GB of storage.
                            </li>
                                <li>
                                If your client’s family surpasses the initial 8 members, expanding their coverage is straightforward with our add-on feature. For an annual fee of $99, they can include an additional 8 family members, ensuring that our platform adapts seamlessly to their evolving needs.
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="card">
                    <div class="card-header">
                        <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion5">
                            Is my clients’ information safe?
                        </a>
                    </div>
                    <div id="proQuestion5" class="collapse" data-bs-parent="#professionalsAccordion">
                        <div class="card-body">
                            At the core of Family Central’s functionality is its security. Our commitment to each and every family member is to keep their personal information safe and secure.  Family Central uses bank-level encryption technology, is SOC 2 compliant, HIPAA compliant, GDPR ready,
                            CCPA ready, and registered with Dun & Bradstreet. Microsoft Azure.com provides our data protection through AES-256 encryption on our applications and services at their global data centers, and Artic Wolf provides 24/7 monitoring detection, risk management, and 
                            proactive security posture for Family Central, as well as global Fortune 100 companies. 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="get_started_section">
    <div class="px-90 m-auto">
        <div class="get_started_content d-grid align-items-center">
            <div class="get_started_image">
                <img class="w-100" src="/assets/images/coworkers-watching-a-macbook-mockup-sitting-on-a-sofa.webp" alt="" loading="lazy">
            </div>
            <div class="get_started_box">
                <h2 class="h2 mb-4">Are you ready to get started with Family Central?</h2>
                <form action="#" method="post">
                    <div class="form-group get_started_field">
                        <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address">
                        <button type="submit" class="primary_btn">Sign up</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>